import JoinTheChallenge from 'components/Content/GameDetails/JoinTheChallenge/JoinTheChallenge';

export default JoinTheChallenge;
